import { useTranslation } from "react-i18next";

interface NotificationHeaderProps {
  unreadCount: number;
  loading: boolean;
  onMarkAllAsRead: () => void;
}

const NotificationHeader = ({ unreadCount, loading, onMarkAllAsRead }: NotificationHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
        {t("admin.notifications.title")}
      </h3>
      {unreadCount > 0 && (
        <button
          onClick={onMarkAllAsRead}
          className="text-xs font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={loading}
        >
          {loading ? t("admin.notifications.marking") : t("admin.notifications.markAllAsRead")}
        </button>
      )}
    </div>
  );
};

export default NotificationHeader;

